import { useTranslation } from 'react-i18next';

const images = [
  'https://readdy.ai/api/search-image?query=Premium modern Quebec cottage house with new architectural asphalt shingle roof in upscale suburban neighborhood, IKO Cambridge style shingles, two-story contemporary home, large windows, manicured landscaping, warm summer light, professional real estate photography, no people',
  'https://readdy.ai/api/search-image?query=Luxury Quebec house with standing seam metal roof in dark slate color, modern suburban architecture, premium residential area, contemporary design with clean lines, landscaped garden, overcast day, professional real estate photography, no people',
  'https://readdy.ai/api/search-image?query=Modern Quebec bungalow with new double-layer architectural asphalt shingle roof, wide eaves, contemporary siding, mature landscaping, summer day, clean suburban street, professional real estate photography style, no people',
];

export default function ProjetsRecents() {
  const { t } = useTranslation('saintnicolas');

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-manrope font-bold text-slate-primary text-center mb-10 md:mb-14">
          {t('projets_h2')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {[1, 2, 3].map((i) => (
            <div key={i} className="rounded-lg overflow-hidden bg-soft-gray">
              <div className="h-[200px] md:h-[240px] overflow-hidden">
                <img
                  src={images[i - 1]}
                  alt={`projet toiture Saint-Nicolas ${i} — couvreur RBQ à Lévis`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="400"
                  height="300"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-manrope font-bold text-slate-primary mb-2">
                  {t(`projet_${i}_title`)}
                </h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                  {t(`projet_${i}_desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}